<div class="store-banner-analysis-panel-container container">
  <div class="header-container" fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
      <h1 class="mat-h1 color-primary text-small-caps no-bottom-margin">
        {{ 'bannerAnalysis.title' | translate }}: {{store?.banner?.name || ('bannerAnalysis.noBanner' | translate)}}
      </h1>
      <mtn-what-is-this [text]="PANEL_DESCRIPTION"></mtn-what-is-this>
    </div>
    <div *ngIf="!!marketName">
      <small>{{ 'bannerAnalysis.in' | translate }} {{marketName}} CBSA</small>
    </div>
  </div>
  <hr style="margin-bottom: 30px;" />
  <div *ngIf="isLoading; else content" style="position: relative">
    <mtn-spinner [size]="SpinnerSize.LARGE" [on]="true"></mtn-spinner>
  </div>
  <ng-template #content>
    <div class="no-banner-container container default-padding" fxLayout="row" fxLayoutAlign="start center"
         fxLayoutGap="15px" *ngIf="!store?.banner?.uuid" style="margin-bottom: 15px">
      <fa-icon icon="exclamation-triangle"></fa-icon>
      <span>
        <strong>{{ 'bannerAnalysis.independentOrMissing' | translate }}</strong> -
        {{ 'bannerAnalysis.independentDescription' | translate }}
      </span>
    </div>
    <div class="no-data-container container default-padding" fxLayout="row" fxLayoutAlign="start center"
         fxLayoutGap="15px" *ngIf="store?.banner?.uuid && (!comparisonSalesSqft || !comparisonSalesVolume || !comparisonStoreCount || hasDataLoadError)" style="margin-bottom: 15px">
      <fa-icon icon="info-circle"></fa-icon>
      <span>
        <strong>Insufficient Data</strong> -
        We don't have sufficient data to display banner analysis for this store at this time.
      </span>
    </div>
    <div fxLayout="row wrap" fxLayoutGap="15px">
      <mtn-banner-analysis-card [comparison]="comparisonSalesSqft" [store]="store"
                                *ngIf="comparisonSalesSqft"></mtn-banner-analysis-card>
      <mtn-banner-analysis-card [comparison]="comparisonSalesVolume" [store]="store"
                                *ngIf="comparisonSalesVolume"></mtn-banner-analysis-card>
      <mtn-banner-analysis-card [comparison]="comparisonStoreCount" [store]="store"
                                *ngIf="comparisonStoreCount"></mtn-banner-analysis-card>
    </div>
  </ng-template>
</div>
